import { Box, UndoIcon, Row } from "@hightouch/htui";
import { RouterLink } from "src/router";

type OtherOptionsProps =
  | { variant: "link"; to: string; onClick?: never }
  | { variant: "button"; onClick: () => void; to?: never };

export function OtherOptions({ variant, ...props }: OtherOptionsProps) {
  const Component = variant === "link" ? RouterLink : "button";
  const componentProps =
    variant === "link" ? { to: props.to } : { onClick: props.onClick };

  return (
    <Row
      as={Component}
      {...componentProps}
      bg="base.lightBackground"
      borderBottomRadius="lg"
      borderTopWidth="hairline"
      borderTopStyle="solid"
      borderColor="gray.300"
      color="text.tertiary"
      fontSize="md"
      fontWeight="semibold"
      lineHeight="16px"
      gap={1.5}
      p={2}
      pos="absolute"
      bottom="-0.5px"
      left="50%"
      transform="translateY(100%) translateX(-50%)"
      _focusVisible={{ boxShadow: "outline" }}
    >
      <Box as={UndoIcon} />
      Other options
    </Row>
  );
}
